export default __webpack_public_path__ + "static/1960_1970-a317fb2e4d781950db590d766464c9ca.mp4";